import style from './Icons.scss';

export const TickIcon = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={style.tickIcon}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7171 2.54766L4.98704 9.55253C4.61234 9.94277 4.0128 9.94277 3.6381 9.55253L0.28103 6.02752C-0.0936766 5.63728 -0.0936766 5.0074 0.28103 4.61776C0.655736 4.22752 1.25527 4.22752 1.62997 4.61776L4.32786 7.43792L10.3828 1.1379C10.7575 0.747655 11.357 0.747655 11.7318 1.1379C12.0918 1.52755 12.0918 2.15743 11.7171 2.54766H11.7171Z"
      fill="white"
    />
  </svg>
);
